<template>
  <div class="profile">
      <v-layout row wrap>
        <v-flex lg7 md8 sm10 xs10 class="center" style="max-width: 950px !important;">
          <v-container grid-list-md class="pa-2 container-width">
              <v-card>
                  <v-card-text>
                  <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                      <img src="/images/bg-login.jpg" style="height: 75px; border-radius: 50%;" />
                      <br/><br/>
                      <h2>{{userInfo.syndication && userInfo.syndication !=null ? userInfo.syndication.syndicate_name : 'None' }}</h2>
                      <br/>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap style="text-align: left;">
                    <v-flex lg6 md6 sm12 xs12>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Full Name: <b>{{userInfo.syndication && userInfo.syndication !=null ? userInfo.syndication.syndicate_name : 'None' }}</b>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Abbreviation: <b>{{userInfo.syndication && userInfo.syndication !=null ? userInfo.syndication.syndicate_abbreviation : 'None'}}</b>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Pay day/s: <span class="wrap"><b>{{userInfo.syndication !=null ? userInfo.syndication && userInfo.syndication.pay_days && userInfo.syndication.pay_days.toString() : 'None'}}</b></span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      <v-flex lg5 md5 sm12 xs12>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Default Participation: <b>{{userInfo.syndication !=null && userInfo.syndication.syndicate_participation_percent ? userInfo.syndication.syndicate_participation_percent : 0}}%</b>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Managment Fee: <b>{{userInfo.syndication !=null && userInfo.syndication.syndicate_management_fee_percentage ? userInfo.syndication.syndicate_management_fee_percentage : 0}}%</b>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          Syndication Fee: <b>{{userInfo.syndication !=null && userInfo.syndication.syndicate_fee_percentage ? userInfo.syndication.syndicate_fee_percentage : 0}}%</b>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    </v-layout>
                  <br/><br/>
                  <div class="tabset" style="text-align: left;">
                    <!-- Tab 1 -->
                    <input type="radio" name="tabset" id="tab1" aria-controls="contact-email" checked>
                    <label for="tab1">Contact & Email</label>
                    <!-- Tab 2 -->
                    <input type="radio" name="tabset" id="tab2" aria-controls="login-credentials">
                    <label for="tab2">Login Credentials</label>
                    <!-- Tab 3 -->
                    <input type="radio" name="tabset" id="tab3" aria-controls="bank-account">
                    <label for="tab3">Bank Account</label>
                    <div class="tab-panels">
                      <section id="contact-email" class="tab-panel">
                        <div class="card-class">
                            <v-card color="white" class="black--text elevation-0">
                              <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                                  <v-layout row wrap>
                                  <v-flex lg6 md6 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        Contact Person: <b>{{userInfo.name}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        Phone Number: <b>{{userInfo.syndication.syndicate_phone.syndicate_phone_number != null ? userInfo.syndication.syndicate_phone.syndicate_phone_number : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        Phone Type: <b>{{userInfo.syndication.syndicate_phone.syndicate_phone_type != null ? userInfo.syndication.syndicate_phone.syndicate_phone_type : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        <span class="esign-email">E-Sign Email: <b>{{userInfo.syndication.syndicate_esign_email}}</b></span>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        CC Email: <b>{{userInfo.syndication !=null ? userInfo.syndication && userInfo.syndication.syndicate_cc_emails && userInfo.syndication.syndicate_cc_emails.toString() : 'None'}}</b>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex lg5 md5 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        Address: <b>{{userInfo.syndication.syndicate_address.syndicate_street != null ? userInfo.syndication.syndicate_address.syndicate_street : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        City: <b>{{userInfo.syndication.syndicate_address.syndicate_city != null ? userInfo.syndication.syndicate_address.syndicate_city : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        State: <b>{{userInfo.syndication.syndicate_address.syndicate_state != null ? userInfo.syndication.syndicate_address.syndicate_state : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                      <v-flex lg12 md12 sm12 xs12>
                                        Zip: <b>{{userInfo.syndication.syndicate_address.syndicate_zip != null ? userInfo.syndication.syndicate_address.syndicate_zip : 'N/A'}}</b>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex lg1 md1 sm12 xs12>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon style="float: right; margin-top: 0px;" @click="openEditDialog()">
                                          <v-icon>edit</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Edit</span>
                                    </v-tooltip>
                                  </v-flex>
                                  </v-layout>
                              </v-container>
                            </v-card>
                            </div>
                      </section>
                      <section id="login-credentials" class="tab-panel">
                        <div class="card-class">
                          <v-card color="white" class="black--text elevation-0">
                            <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                                <v-layout row wrap>
                                <v-flex lg6 md6 sm12 xs12>
                                  <v-layout row wrap style="margin: 0px;">
                                    <v-flex lg12 md12 sm12 xs12>
                                      User Name: <b>{{userInfo.email}}</b>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex lg5 md6 sm12 xs12>
                                  <v-layout row wrap style="margin: 0px;">
                                    <v-flex lg12 md12 sm12 xs12>
                                      Password: <b>************</b>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex lg1 md1 sm12 xs12>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" icon style="float: right; margin-top: 0px;" @click="openPasswordDialog()">
                                        <v-icon>edit</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Reset</span>
                                  </v-tooltip>
                                </v-flex>
                                </v-layout>
                            </v-container>
                          </v-card>
                          </div>
                      </section>
                      <section id="bank-account" class="tab-panel">
                        <div class="card-class">
                          <v-card color="white" class="black--text elevation-0">
                            <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                                <v-layout row wrap>
                                <v-flex lg6 md6 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12>
                                      Bank Name: <b>{{userInfo.syndication !=null ? userInfo.syndication.syndicate_bank_name : 'None'}}</b>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12>
                                      Account Number: <b>{{userInfo.syndication !=null ? userInfo.syndication.syndicate_account_number : 'None'}}</b>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex lg5 md5 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12>
                                      Routing Number: <b>{{userInfo.syndication !=null ? userInfo.syndication.syndicate_routing_number : 'None'}}</b>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex lg1 md1 sm12 xs12>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" icon style="float: right; margin-top: 0px;" @click="openBankAccountDialog()">
                                        <v-icon>edit</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Edit</span>
                                  </v-tooltip>
                                </v-flex>
                                </v-layout>
                            </v-container>
                          </v-card>
                          </div>
                      </section>
                    </div>
                  </div>
                  <!-- TABS END -->
                </v-card-text>
              </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    
    <v-dialog v-model="editDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Contact & Email</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeEditDialog()">
              <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.name"
                    label="Contact Person"
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_phone.syndicate_phone_number"
                    label="Phone Number"
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg4 md4 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_phone.syndicate_phone_type"
                    label="Phone Type"
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_esign_email"
                    label="E-Sign Email"
                    :rules="[rules.required, rules.email]"
                    hint="Email for receiving Schedule A and Nightly Syndication Report."
                    persistent-hint
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg6 md6 sm12 xs12>
                    <v-combobox
                      v-model="syndicateCcEmails"
                      :items="syndicateCcEmails"
                      label="Add CC Emails"
                      autocomplete="off"
                      hint="Hit enter to add multiple"
                      persistent-hint
                      hide-selected
                      multiple
                      chips
                    ></v-combobox>
                </v-flex>
                </v-layout>
                
                <v-layout row wrap>  
                  <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_address.syndicate_street"
                    label="Address"
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_address.syndicate_city"
                    label="City"
                    required
                  ></v-text-field>
                  </v-flex>
                  
                  <v-flex lg6 md6 sm12 xs12>
                    <v-select
                      v-model="userInfo.syndication.syndicate_address.syndicate_state"
                      :items="syndicate_state"
                      color="blue darken-2"
                      label="State"
                      return-object
                      autocomplete
                      hide-details
                    ></v-select>
                  <!-- <v-text-field
                    v-model="userInfo.syndication.syndicate_address[0].syndicate_state"
                    label="State"
                    required
                  ></v-text-field> -->
                  </v-flex>
                  
                  <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_address.syndicate_zip"
                    label="Zip"
                    required
                  ></v-text-field>
                  </v-flex>
                  
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeEditDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="submitContactInfo()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResetPassword 
      v-if="passwordDialog" 
      @closePasswordDialog="closePasswordDialog" 
      :passwordDialog="passwordDialog" 
    />
    
    <v-dialog v-model="bankAccountDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Bank Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeBankAccountDialog()">
              <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_bank_name"
                    label="Bank Name"
                    required
                  ></v-text-field>
                </v-flex>
                </v-layout>
        
                <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_account_number"
                    label="Account Number"
                    required
                  ></v-text-field>
                </v-flex>
                </v-layout>
                
                <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.syndication.syndicate_routing_number"
                    label="Routing Number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeBankAccountDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="updateSyndicateBankInfo()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import axios from "axios";
import ResetPassword from './Dialogs/ResetPassword'
import {URL} from '../../env'

export default {
  components: {
    ResetPassword
  },
  data() {
    return {
      syndicateCcEmails: [],
      syndicate_state: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansa",
        "Kentucky",
        "Lousiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ],
      editDialog: false,
      passwordDialog: false,
      bankAccountDialog: false,
      rules: {
        min: v => v.length >= 8 || 'Min 8 characters',
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      userInfo: {
        syndication:{
          syndicate_phone: {},
          syndicate_address: {}
        }
      },
    };
  },
  mounted() {
    this.getProfile();
  },
  
  methods: {
      openEditDialog() {
          this.editDialog = true;
      },
      closeEditDialog() {
          this.editDialog = false;
      },
      
      openPasswordDialog() {
        this.passwordDialog = true;
      },
      closePasswordDialog() {
        this.passwordDialog = false;
      },
      
      openBankAccountDialog() {
          this.bankAccountDialog = true;
      },
      closeBankAccountDialog() {
          this.bankAccountDialog = false;
      },
      async getProfile() {
        const resp = await axios.get(`${URL}/api/getPortalUserProfile/${localStorage.getItem("user_id")}`);
        this.userInfo = resp.data[0]
        this.userInfo.syndication.syndicate_phone = resp.data[0].syndication.syndicate_phone.length>0 ? resp.data[0].syndication.syndicate_phone[0] : {}
        this.userInfo.syndication.syndicate_address = resp.data[0].syndication.syndicate_address.length>0 ? resp.data[0].syndication.syndicate_address[0] : {}
        this.syndicateCcEmails = JSON.parse(
          resp.data[0].syndication.syndicate_cc_emails
        );
      },
      async submitContactInfo() {
        let data = {
          user_id: this.userInfo.id,
          name: this.userInfo.name,
          syndicate_id: this.userInfo.syndication.id,
          syndicate_phone_number: this.userInfo.syndication.syndicate_phone.syndicate_phone_number, 
          syndicate_phone_type: this.userInfo.syndication.syndicate_phone.syndicate_phone_type, 
          syndicate_phone_id: this.userInfo.syndication.syndicate_phone.id ? this.userInfo.syndication.syndicate_phone.id : 0, 
          syndicate_street: this.userInfo.syndication.syndicate_address.syndicate_street, 
          syndicate_city: this.userInfo.syndication.syndicate_address.syndicate_city, 
          syndicate_state: this.userInfo.syndication.syndicate_address.syndicate_state, 
          syndicate_zip: this.userInfo.syndication.syndicate_address.syndicate_zip, 
          syndicate_esign_email: this.userInfo.syndication.syndicate_esign_email, 
          syndicate_address_id: this.userInfo.syndication.syndicate_address.id ? this.userInfo.syndication.syndicate_address.id : 0,
          syndicate_cc_emails: this.syndicateCcEmails, 
        }
        const resp = await axios.post(`${URL}/api/updatePortalUserProfile`, data);
        this.closeEditDialog();
      },
      async updateSyndicateBankInfo() {
        let data = {
          user_id: this.userInfo.id,
          syndicate_id: this.userInfo.syndication.id ? this.userInfo.syndication.id : 0, 
          syndicate_bank_name: this.userInfo.syndication.syndicate_bank_name,
          syndicate_account_number: this.userInfo.syndication.syndicate_account_number,
          syndicate_routing_number: this.userInfo.syndication.syndicate_routing_number,
        }
        const resp = await axios.post(`${URL}/api/updateSyndicateBankInfo`, data);
        this.closeBankAccountDialog();
        this.getProfile();
      }
  },

};
</script>

<style scoped>
.container-width {
  max-width: 100% !important;
}

.profile {
  line-height: 1;
}

.container-style {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
}

.card-class {
  margin: 1px 0px;
}

.esign-email {
  word-wrap: break-word;
}

.wrap {
  word-wrap: break-word;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* TABS */
.tabset > input[type="radio"] {
  position: absolute;
  left: -200vw;
}

.tabset .tab-panel {
  display: none;
}

.tabset > input:first-child:checked ~ .tab-panels > .tab-panel:first-child,
.tabset > input:nth-child(3):checked ~ .tab-panels > .tab-panel:nth-child(2),
.tabset > input:nth-child(5):checked ~ .tab-panels > .tab-panel:nth-child(3),
.tabset > input:nth-child(7):checked ~ .tab-panels > .tab-panel:nth-child(4),
.tabset > input:nth-child(9):checked ~ .tab-panels > .tab-panel:nth-child(5),
.tabset > input:nth-child(11):checked ~ .tab-panels > .tab-panel:nth-child(6) {
  display: block;
}

.tabset > label {
  position: relative;
  display: inline-block;
  padding: 15px 15px 25px;
  border: 1px solid transparent;
  border-bottom: 0;
  cursor: pointer;
  font-weight: 600;
}

.tabset > label::after {
  content: "";
  position: absolute;
  left: 15px;
  bottom: 10px;
  width: calc(100% - 28px);
  height: 4px;
  background: #8d8d8d;
}

input:focus-visible + label {
  outline: 2px solid rgba(0,102,204,1);
  border-radius: 3px;
}

.tabset > label:hover,
.tabset > input:focus + label,
.tabset > input:checked + label {
  color: #06c;
}

.tabset > label:hover::after,
.tabset > input:focus + label::after,
.tabset > input:checked + label::after {
  background: #06c;
}

.tabset > input:checked + label {
  border-color: #ccc;
  border-bottom: 1px solid #fff;
  margin-bottom: -1px;
}

.tab-panel {
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
/* TABS END */
</style>